import {
  CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS,
  CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART,
  CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART,
  CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART,
  SET_MENOPAUSE_LOADING,
  SET_MENOPAUSE_ERROR,
} from "../actions/PatientMenopauseType"

const initialState = {
  patientMenopauseCharts: [],
  isLoading: false,
  error: null,
}

export default function PatientMenopauseChartReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MENOPAUSE_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        error: null,
      }

    case SET_MENOPAUSE_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }

    case CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS:
      return {
        ...state,
        patientMenopauseCharts: action.payload,
        isLoading: false,
        error: null,
      }

    case CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART:
      return {
        ...state,
        patientMenopauseCharts: [...state.patientMenopauseCharts, action.payload],
        isLoading: false,
        error: null,
      }

    case CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART:
      return {
        ...state,
        patientMenopauseCharts: state.patientMenopauseCharts.filter((item) => {
          // Handle different possible ID field names
          const itemId = item.menopause_id || item._id || item.id
          const deleteId = action.payload.menopause_id
          return itemId !== deleteId
        }),
        isLoading: false,
        error: null,
      }

    case CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART:
      return {
        ...state,
        patientMenopauseCharts: state.patientMenopauseCharts.map((item) => {
          const itemId = item.menopause_id || item._id || item.id
          const updateId = action.payload.menopause_id || action.payload._id || action.payload.id
          return itemId === updateId ? action.payload : item
        }),
        isLoading: false,
        error: null,
      }

    default:
      return state
  }
}
